import { createSlice } from '@reduxjs/toolkit';
import serviceEndpoints from 'app/api/services/serviceEndpoints';
import _ from 'lodash';
import { errorHandler } from 'app/utils/errorHandler';

const initialState = {
  services: {
    alphabetic: [],
    lastOnes: [],
    mostPopular: [],
    summary: [],
  },
  internalServices: {},
  documents: [],
  details: {},
  allServicesStatus: [],
  allServices: [],
};

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    getServices(state, action) {
      state.services = action.payload;
    },
    clearServices(state, action) {
      state.services = initialState.services;
    },
    getInternalServices(state, action) {
      state.internalServices = action.payload;
    },
    getServiceDocuments(state, action) {
      state.documents = action.payload;
    },
    clearServiceDocuments(state, action) {
      state.documents = initialState.documents;
    },
    updateServiceDetails(state, action) {
      state.details = action.payload;
    },
    clearServiceDetails(state, action) {
      state.details = initialState.details;
    },
    getAllServicesStatus(state, action) {
      state.allServicesStatus = action.payload;
    },
    getAllServices(state, action) {
      state.allServices = action.payload;
    },
  },
});

export const getAllLetters = services => services.reduce((acc, { letter }) => [...acc, letter], []);

export const fetchServices = (user, internal = false) => async dispatch => {
  try {
    let response = [];
    if (internal) {
      response = await serviceEndpoints.getInternalServices();
      const ordenedServices = _.orderBy(response.data, ['nmServico'], ['asc']);
      dispatch(getInternalServices(ordenedServices));
    } else {
      if (!user || !user.username || !user.boAtivo) {
        response = await serviceEndpoints.getGuestServices();
      } else {
        response = await serviceEndpoints.getServices();
      }

      dispatch(getServices(response.data));
    }
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchAllServicesStatus = () => async dispatch => {
  try {
    let response = [];
    response = await serviceEndpoints.getAllServicesStatus();
    const ordenedStatus = _.orderBy(response.data, ['deSituacao'], ['asc']);
    dispatch(getAllServicesStatus(ordenedStatus));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchAllServices = () => async dispatch => {
  try {
    let response = [];
    response = await serviceEndpoints.getAllServices();
    const ordenedServices = _.orderBy(response.data, ['nmServico'], ['asc']);
    dispatch(getAllServices(ordenedServices));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fetchServiceDocuments = params => async dispatch => {
  try {
    let result = [];
    const response = await serviceEndpoints.getServiceDocuments({
      ...params,
    });
    if (response.status === 200 && response.data) {
      response.data.forEach(d => {
        const t = _.find(result, ['cdTipoDocumento', d.cdTipoDocumento]);
        if (!t) result.push(d);
      });
    }
    dispatch(getServiceDocuments(result));
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const {
  getServices,
  clearServices,
  getInternalServices,
  updateServicesList,
  getServiceDocuments,
  clearServiceDocuments,
  updateServiceDetails,
  clearServiceDetails,
  getAllServicesStatus,
  getAllServices,
} = servicesSlice.actions;

export default servicesSlice;
